<div class="container">
    <smart-icon tid="filter_icon" [name]="iconName" (click)="onShowFilterContextMenu($event)" class="light"></smart-icon>
    <tam-context-menu [config]="filterContextMenuConfig"></tam-context-menu>
</div>